export enum UserType {
    Internal = "Internal",
    Freelancer = "Freelancer",
    Client = "Client",
  }
  